import './AboutUs.scss';
import {useRef, useState, useEffect} from 'react';
import {Container, Row, Col, Image} from 'react-bootstrap';
import aboutImg from '../assets/about-us.png';

function AboutUs() {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

// Original list of items
  const cardsData = [
    { id: 1, icon: '⚡', title:'Fast Execution', text: "Quick turnaround without compromising quality." },
    { id: 2, icon: '🎯', title:'Business Focused', text: "Solutions designed to generate leads & growth." },
    { id: 3, icon: '🧠', title:'Smart Strategy', text: "We combine tech + marketing for best results." },
  ];

  // Duplicate the array for a seamless loop
  const loopedCards = [...cardsData];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Optional: Disconnect observer if you only want to trigger it once
          // observer.unobserve(entry.target);
        } else {
          // Resets animation when user scrolls away
          setIsVisible(false); 
        }
      },
      { threshold: 0.2 } // Triggers when 20% of the section is visible
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    // Cleanup observer on unmount
    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
      <Container ref={containerRef.about} id="about-us" className={`py-4`}>
        <Row className="justify-content-md-center">
            <Col md lg="6">
                <h1 className="section-title">Why us</h1>
                <p className="my-3">
                    Our <b>CubeTech Studio</b> team is passionate about developing strategies that help your business grow. We are dedicated to provide high quality services that spark in creating a long lasting impression of the brand.
                </p>
                <p className="my-3 bold-text primary-text">
                    We believe that every brand has a unique story so our mission is to enhance your story with a purpose.
                </p> 
                <p className="my-3">
                    By creating attractive visuals, impactful content & digital smart ideas, we offer tailored solutions that align perfectly with our client's goals. Our approach is to ensure each campaign is not just visually appealing but it is results-driven too.
                </p>
            </Col>
            <Col md lg="6">
                <Image src={aboutImg} alt="Cubetech Studio Team" width="100%" />
            </Col>
        </Row>
        <Row ref={containerRef} className={`about-features ${isVisible ? 'is-visible' : ''}`}>
            {loopedCards.map((card, index) => (
                <Col md key={`${card.id}-${index}`}>
                    <div className="about-card">
                        <span>{card.icon}</span>
                        <div>
                        <h5>{card.title}</h5>
                        <p>{card.text}</p></div>
                    </div>
                </Col>
             ))}
        </Row>
        
      </Container>
  );
}

export default AboutUs;